<script lang="ts">
  import { Video } from '@reuters-graphics/graphics-components';
  import { assets } from '$app/paths';
  import { truthy } from '$utils/propValidators';

  interface Props {
    videos: Array<{
      src: string;
      ariaDescription: string;
      loopVideo?: string | boolean;
      notes?: string;
    }>;
  }

  let { videos }: Props = $props();
</script>

<div class="video-grid">
  <div class="video-container">
    <div class="bottom-row">
      {#each videos as video, index}
        {#if index !== 1}
          <div class="video-wrapper">
            <Video
              ariaDescription={video.ariaDescription}
              src={`${assets}/${video.src}`}
              loopVideo={truthy(video.loopVideo)}
              notes={video.notes}
              showControls={false}
            />
          </div>
        {/if}
      {/each}
    </div>
    {#each videos as video, index}
      {#if index === 1}
        <div class="video-wrapper">
          <Video
            ariaDescription={video.ariaDescription}
            src={`${assets}/${video.src}`}
            loopVideo={truthy(video.loopVideo)}
            notes={video.notes}
            showControls={false}
          />
        </div>
      {/if}
    {/each}
  </div>
</div>

<style lang="scss">
  .video-grid {
    display: flex;
    justify-content: center;
    margin: 2rem auto;
    max-width: 100%;
  }

  .video-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
    width: 800px;
    max-width: 100%;
  }

  .bottom-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 10px;
    width: 100%;
  }

  .video-wrapper {
    width: 100%;
  }

  .bottom-row .video-wrapper {
    width: 41%;
    flex-shrink: 0;
  }

  .video-container > .video-wrapper {
    margin-top: -70px;
    filter: brightness(1.2) contrast(1.3);
  }

  .bottom-row .video-wrapper:nth-child(1) {
    filter: brightness(1.4) contrast(1.3);
  }

  .bottom-row .video-wrapper:nth-child(2) {
    filter: brightness(1.2) contrast(1.2);
  }

  .caption {
    text-align: center;
    margin: 1rem auto 2rem;
    max-width: 100%;
    font-size: 0.9rem;
    color: #666;
  }

  @media (min-width: 1000px) {
    .video-grid {
      max-width: 70%;
    }

    .caption {
      max-width: 70%;
    }
  }

  @media (max-width: 768px) {
    .bottom-row {
      flex-direction: column;
      align-items: center;
      gap: 0;
    }

    .video-wrapper {
      width: 100%;
    }

    .video-container > .video-wrapper {
      margin-top: 0;
    }

    .bottom-row .video-wrapper {
      width: 100%;
    }

    .caption {
      padding: 0 1rem;
    }
  }
</style>
